/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { Component, Fragment } from 'react';
import {
  Heading,
  Paragraph,
  Collapsible,
  Icon,
  HtmlParser,
  Button,
  Link,
} from 'components/common';
import {
  string, arrayOf, shape, func, bool,
} from 'prop-types';
import classNames from 'classnames';

import './FaqContextualContainer.scss';

export function questionWithArrow(question, selected) {
  return (
    <div className="question questions-arrow">
      <div><Paragraph primary collapsible className="question-body"><strong>{question}</strong></Paragraph></div>
      <Icon primary className="expand" name={selected ? 'chevron_up' : 'chevron_down'} />
    </div>
  );
}

export function questionWithQuestionMark(question) {
  return (
    <div className="question questions-mark">
      <Icon className="expand" name="question" />
      <Paragraph primary className="question-body"><strong>{question}</strong></Paragraph>
    </div>
  );
}

export class FaqContextualPanel extends Component {
  static propTypes = {
    sidebar: bool,
    heading: string.isRequired,
    subheading: string,
    faqs: arrayOf(shape({
      question: string.isRequired,
      answer: string.isRequired,
    }).isRequired).isRequired,
    questionRender: func.isRequired,
    viewAllCta: shape({}),
  };

  static defaultProps = {
    sidebar: false,
    subheading: '',
    viewAllCta: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      expandedIndex: null,
    };
    this.toggleFaq = this.toggleFaq.bind(this);
  }

  toggleFaq(index) {
    this.setState((prev) => {
      if (prev.expandedIndex === index) {
        return {
          expandedIndex: null,
        };
      }
      return {
        expandedIndex: index,
      };
    });
  }

  render() {
    const {
      sidebar,
      heading,
      faqs,
      subheading,
      questionRender,
      viewAllCta,
    } = this.props;
    const { expandedIndex } = this.state;
    return (
      <div className={classNames('faq-contextual-panel', { sidebar })} data-selector-type="faq-contextual-panel">
        {(heading || subheading) && (
          <div className="faqs-titles" data-selector-type="faq-contextual-panel-title">
            {heading && (
              <Fragment>
                {!sidebar
                  ? <Heading className="faqs-title" as="h2">{heading}</Heading>
                  : <Paragraph className="faqs-title">{heading}</Paragraph>}
              </Fragment>
            )}
            {subheading && (
              <Paragraph className="faqs-subtitle">{subheading}</Paragraph>
            )}
          </div>
        )}
        <div className="faqs-content" data-selector-type="faqs">
          {faqs && faqs.map((faq, index) => (
            // eslint-disable-next-line
            <div className="faq" key={faq.question + index} data-selector-type="faq" data-selector-index={index}>
              <div className="faq-title" onClick={() => this.toggleFaq(index)} data-selector-type="title">
                {questionRender(faq.question, expandedIndex === index)}
              </div>
              <Collapsible isCollapsed={expandedIndex !== index}>
                <div className="answer" data-selector-type="answer">
                  <HtmlParser htmlString={faq.answer} />
                </div>
              </Collapsible>
            </div>
          ))}
        </div>
        {viewAllCta && viewAllCta.href && (
          <div className="faqs-view-all" data-selector-type="view-all">
            <Link to={viewAllCta.href}>
              <Button
                styleName="ghost"
                rightIconName="chevron_forward"
              >
                {(viewAllCta.title) || ''}
              </Button>
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default function FaqContextualContainer({
  sidebar,
  title,
  questionRender,
  faqs,
  viewAllCta,
}) {
  return (
    <FaqContextualPanel
      sidebar={sidebar}
      heading={title}
      key={title}
      faqs={faqs && faqs.faqs}
      questionRender={questionRender}
      viewAllCta={viewAllCta}
    />
  );
}

FaqContextualContainer.propTypes = {
  sidebar: bool,
  title: string.isRequired,
  questionRender: func.isRequired,
  faqs: shape({}).isRequired,
  viewAllCta: shape({
    href: string,
    title: string,
  }),
};

FaqContextualContainer.defaultProps = {
  sidebar: false,
  viewAllCta: null,
};
